import { CANDIDATE_SECTION_HEADING, CANDIDATE_SECTION_HEADER } from '../constants/candidateFormStyles';

/**
 * Consistent bold category heading for candidate add/edit & profile forms.
 */
export default function CandidateSectionHeader({ title, hint, actions, className = '' }) {
  return (
    <div className={`${CANDIDATE_SECTION_HEADER} ${className}`.trim()}>
      <div className="min-w-0 flex-1">
        <h3 className={`candidate-section-heading ${CANDIDATE_SECTION_HEADING}`}>{title}</h3>
        {hint ? (
          <p className="text-[10px] font-normal text-[hsl(var(--ds-muted-fg))] mt-0.5 leading-snug">{hint}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div> : null}
    </div>
  );
}
